import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedProductStockListResponse, StockExtendedListResponse, StockQueryParams } from '@frontend/stock/types';

export class StockExtendedClient extends APIClient {
    public static readonly endpoint = '/stock-api/ext/v1';

    public static async fetchStocksExtended(queryParams?: ApiQueryParams<StockQueryParams>): Promise<StockExtendedListResponse> {
        return await this.apiPaginated<StockExtendedListResponse, StockQueryParams>(`${this.endpoint}/stocks`, queryParams);
    }

    public static async fetchConsumableStocksExtended(queryParams?: ApiQueryParams<StockQueryParams>): Promise<StockExtendedListResponse> {
        return await this.apiPaginated<StockExtendedListResponse, StockQueryParams>(`${this.endpoint}/consumable-stocks`, queryParams);
    }

    public static async fetchReusableStocksExtended(queryParams?: ApiQueryParams<StockQueryParams>): Promise<StockExtendedListResponse> {
        return await this.apiPaginated<StockExtendedListResponse, StockQueryParams>(`${this.endpoint}/reusable-stocks`, queryParams);
    }

    public static async fetchConsumableProductStocksExtended(queryParams?: ApiQueryParams<StockQueryParams>): Promise<ExtendedProductStockListResponse> {
        return await this.apiPaginated<ExtendedProductStockListResponse, StockQueryParams>(`${this.endpoint}/consumable-product-stocks`, queryParams);
    }

    public static async fetchReusableProductStocksExtended(queryParams?: ApiQueryParams<StockQueryParams>): Promise<ExtendedProductStockListResponse> {
        return await this.apiPaginated<ExtendedProductStockListResponse, StockQueryParams>(`${this.endpoint}/reusable-product-stocks`, queryParams);
    }

    public static async fetchSpotModuleStocksExtended(
        accountId: string,
        spotId: string,
        moduleId: string,
        queryParams?: ApiQueryParams<StockQueryParams>
    ): Promise<StockExtendedListResponse> {
        return await this.apiPaginated<StockExtendedListResponse, StockQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/stocks`,
            queryParams
        );
    }
    public static async fetchSpotSlotStocksExtended(
        accountId: string,
        spotId: string,
        moduleId: string,
        slotId: string,
        queryParams?: ApiQueryParams<StockQueryParams>
    ): Promise<StockExtendedListResponse> {
        return await this.apiPaginated<StockExtendedListResponse, StockQueryParams>(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/slots/${slotId}/stocks`,
            queryParams
        );
    }
}
